<template>
  <b-modal
    id="modal-info"
    :active.sync="isSendInfoSuccess"
    :can-cancel="false"
    scroll="keep"
  >
    <div class="modal-card">
      <div class="modal-body">
        <div class="kyc-pending-img">
          <img src="/static/svg/kyc-pending.svg">
        </div>
        <div class="modal-title">
          <p>{{ $t('kyc.send_info_success') }}</p>
        </div>
        <div class= "content">
          <p>
            {{ $t('kyc.thanks_for_submited') }}
          </p>
        </div>
        <div
          class="is-button full-status-btn"
          data-test="send-info-success--submited-btn"
          @click="$router.push({ name: 'SummaryOfKYC' })"
        >
          {{ $t('kyc.kyc_status') }}
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    isSendInfoSuccess: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-card {
  background-color: #fff;
  border-radius: 5px;
  padding: 58px 80px;
  margin: 0 auto !important;
}
.modal-body {
  width: 100%;
  display: block;
  align-items: center;
  justify-content: center;
}
.kyc-pending-img {
  width: 60px;
  margin: 0 auto;
}
.modal-title {
  text-align: center;
  color: #0559af;
  font-size: 21px;
  font-weight: bold;
  margin: 15px 0 15px 0;
}
.content {
  margin: 0 15px;
}
.is-button {
  font-size: 15px;
  font-weight: bold;
  color: #ffffff;
  height: auto;
  box-shadow: 0 2px 4px -2px rgba(0, 0, 0, 0.5);
  border: 0;
  text-align: center;
  border-radius: 3px;
  cursor: pointer;
}
.full-status-btn {
  background-color: #2193ff;
  width: calc(100% - 20px);
  padding: 13px;
  margin: 10px auto;
}
// Mobile
@media only screen and (max-width: 768px) {
  .modal-card {
    padding: 30px 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/KYC/components/SendInfoSuccess.vue